'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.queryRegion = queryRegion;
exports.queryRegionLevel = queryRegionLevel;

var _requestOlympics = require('@ali/request-olympics');

var _requestOlympics2 = _interopRequireDefault(_requestOlympics);

var _request = require('../adapter/request');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 *判断返回值
 * @param {Object} res 返回值
 * @returns Promise.reject or Promise.resolve
 */
function resErrorJudge(res) {
  if (!res || !res.success) {
    return Promise.reject(res);
  }
  return Promise.resolve(res.data);
}

function queryRegion() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      categoryCode = _ref.categoryCode,
      parentCode = _ref.parentCode,
      currentCode = _ref.currentCode,
      asyncUrl = _ref.asyncUrl,
      sequenceNo = _ref.sequenceNo;

  return _requestOlympics2.default.get((0, _request.transformUrl)(asyncUrl), {
    params: {
      categoryCode: categoryCode,
      parentCode: parentCode,
      currentCode: currentCode,
      sequenceNo: sequenceNo
    }
  }).then(resErrorJudge);
}

function queryRegionLevel() {
  var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      asyncUrl = _ref2.asyncUrl;

  return _requestOlympics2.default.get((0, _request.transformUrl)(asyncUrl)).then(resErrorJudge);
}